import React from "react";

import { faArrowUpRightAndArrowDownLeftFromCenter } from "@fortawesome/pro-regular-svg-icons";
import { faXmark } from "@fortawesome/pro-solid-svg-icons";

import { ButtonIcon } from "@performyard/py-components";

import { useAskPerformYardStore } from "../AskPerformYardStore";

type ChatHeaderProps = {
	className?: string;
};

export const ChatHeader: React.FC<ChatHeaderProps> = ({ className }) => {
	const close = useAskPerformYardStore((state) => state.close);
	const toggleExpand = useAskPerformYardStore((state) => state.toggleExpand);
	const isExpanded = useAskPerformYardStore((state) => state.isExpanded);

	return (
		<div
			className={`box-border flex w-full max-w-full items-center gap-2 rounded-t-lg border-b border-solid border-[#E9EAEC] bg-white p-2 ${className || ""}`}
		>
			<div className="flex min-w-0 flex-1 items-center gap-1 px-1">
				<div className="flex h-6 w-6 shrink-0 items-center justify-center">
					<img
						src="/static/img/py-logo/py-logo-solo.png"
						alt="PerformYard"
						className="h-3 w-3 object-contain"
					/>
				</div>
				<span className="truncate text-neutral-600">Ask PerformYard</span>
			</div>
			<div className="flex shrink-0 items-center gap-1">
				<div className="flex items-center justify-center p-2">
					<ButtonIcon
						icon={faArrowUpRightAndArrowDownLeftFromCenter}
						onClick={toggleExpand}
						variant="standard"
						color="neutral"
						shade={5}
						size={16}
						aria-label={isExpanded ? "Collapse" : "Expand"}
					/>
				</div>
				<div className="flex items-center justify-center p-2">
					<ButtonIcon
						icon={faXmark}
						onClick={close}
						variant="standard"
						color="neutral"
						shade={5}
						size={20}
						aria-label="Close"
					/>
				</div>
			</div>
		</div>
	);
};

export default ChatHeader;
